'use strict';

const get = require('lodash.get');

function getDisplayName({ firstName, lastName, email }) {
    if (firstName && lastName) {
        return `${firstName} ${lastName}`;
    } else if (lastName) {
        return lastName;
    } else if (firstName) {
        return firstName;
    } else if (email) {
        return email.split('@')[0];
    }
    return '';
}

const ContactDealerStore = {
    storeName: 'ContactDealerStore',
    initialState: {
        errors: [],
        hasTrackingFired: false,
        isMessageSending: false,
        isMessageSent: false,
        messageBody: {
            action: { name: 'CONTACT_DEALER' },
            from: {},
            item: {},
            recipients: [],
            textBody: '',
        },
        optimizelyVariant: '',
    },
    reducers: {
        BOOTSTRAP_ITEM_STORE(state, payload) {
            const { rawResult: item = {} } = payload;
            const apiType = `${item.vertical}Item`; // Need to format V2 apiType for MC endpoint
            return {
                ...state,
                messageBody: {
                    ...state.messageBody,
                    item: { apiType, id: item.id },
                    recipients: [
                        {
                            recipientDetails: {
                                displayName: get(item, 'seller.sellerProfile.company', ''),
                                user: { id: get(item, 'seller.id') },
                                userType: 'SELLER',
                            },
                            recipientType: 'TO',
                        },
                    ],
                    subject: `1stdibs Item Inquiry - ${get(item, 'title')}`,
                },
            };
        },
        ENTER_MESSAGE(state, payload) {
            const { value } = payload;
            return { ...state, messageBody: { ...state.messageBody, textBody: value } };
        },
        ENTER_NAME(state, payload) {
            const { value } = payload;
            return {
                ...state,
                messageBody: { ...state.messageBody, from: { displayName: value } },
            };
        },
        SET_USER_VALUES(state, payload) {
            const { displayName, user } = payload;
            return {
                ...state,
                messageBody: {
                    ...state.messageBody,
                    from: {
                        displayName: displayName || getDisplayName(user.profile || {}),
                        user: { id: user.userId || user.serviceId || user.id },
                        userEmail: get(user, 'profile.email'),
                        userType: 'BUYER',
                    },
                },
            };
        },
        SET_OPTIMIZELY_VARIANT(state, payload) {
            const { optimizely } = payload;
            return { ...state, optimizelyVariant: optimizely };
        },
        MESSAGE_SEND_END(state) {
            return { ...state, isMessageSent: true, isMessageSending: false };
        },
        MESSAGE_SEND_BEGIN(state) {
            return { ...state, isMessageSending: true };
        },
        PDP_CONTACT_FORM_ERRORS(state, payload) {
            const { errors } = payload;
            return { ...state, errors };
        },
        TRACKING_FIRED(state) {
            return { ...state, hasTrackingFired: true };
        },
    },
    getters: {
        getErrors: state => state.errors,
        getMessage: state => state.messageBody.textBody,
        getMessageSending: state => state.isMessageSending,
        getMessageSent: state => state.isMessageSent,
        getName: state => state.messageBody.from.displayName,
        getVariant: state => state.optimizelyVariant,
        getTrackingFired: state => state.hasTrackingFired,
    },
};

module.exports = ContactDealerStore;



// WEBPACK FOOTER //
// ./assets/js/newPdp/stores/ContactDealerStore.es.js